import { useQuery } from "@tanstack/react-query";
import { getAllLeads } from "../../services/apiLeads";
import toast from "react-hot-toast";

export function useGetLeads() {
  return useQuery({
    queryKey: ["leads"],
    queryFn: getAllLeads,
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
